/* ⚠️ GENERATED from app/services/avatarBlink.ts by gen-twins.mjs — edit the TypeScript, not this. */
/* ═══════════════════════════════════════════════════════════════════════════
   services/avatarBlink.ts — when a face should blink.

   🟥 THE AVATAR COULD ALREADY BLINK AND NOTHING EVER ASKED IT TO. The scene has
      had a `blink()` motion since it was written, the catalogue ships
      `eyeBlinkLeft` / `eyeBlinkRight` morph targets on the face, and the only
      callers were a tap handler and a peek animation. So a profile sat there
      with its eyes open, forever, which is the one thing a face never does.

   🟥 AND A METRONOME IS WORSE THAN NOTHING. A blink exactly every four seconds
      reads as a machine — the eye is very good at spotting a period. Real
      blinking is irregular, roughly every two to eight seconds, and about a
      fifth of the time it comes in pairs.

   🟢 NO TIMER. The schedule is a pure function of "now" and two random numbers,
      and the scene asks it on the frames it is already drawing. A full-body
      avatar breathes, so those frames exist whether or not anybody blinks;
      adding a blink costs two comparisons and never wakes anything up.
   ═══════════════════════════════════════════════════════════════════════════ */

/** How long one blink takes — matches the scene's own blink motion. */
export const BLINK_MS = 200;
/** The gap between blinks: a spontaneous human blink rate, near enough. */
export const MIN_GAP_MS = 2200;
export const MAX_GAP_MS = 7600;
/** How often a blink comes in a pair. */
export const DOUBLE_CHANCE = 0.22;
/** The gap inside a pair — short enough to read as one gesture. */
export const DOUBLE_GAP_MS = 240;
const unit = r => Number.isFinite(r) ? r < 0 ? 0 : r > 1 ? 1 : r : 0.5;

/**
 * The next blink after one has finished.
 *
 * `r` and `r2` are two numbers in [0,1) — the caller's randomness, passed in so
 * the schedule can be tested without stubbing the global generator.
 */
export function scheduleBlink(now, r, r2) {
  const gap = MIN_GAP_MS + unit(r) * (MAX_GAP_MS - MIN_GAP_MS);
  return {
    at: now + gap,
    left: unit(r2) < DOUBLE_CHANCE ? 2 : 1
  };
}

/**
 * Advance the plan at time `now`.
 *
 * 🟥 THE FIRST BLINK IS NOT AT ZERO. A face that blinks the instant it appears
 *    reads as a glitch in the load, not as a living thing — so a fresh plan is
 *    always at least MIN_GAP_MS away, which `scheduleBlink` guarantees.
 *
 * 🟥 AND A LATE FRAME DOES NOT FIRE A BURST. If the view was backgrounded for a
 *    minute, `now` jumps far past `at`; blinking once and rescheduling from NOW
 *    (rather than from `at`) means a phone coming back from sleep blinks once,
 *    not eleven times in a row catching up.
 */
export function stepBlink(plan, now, r, r2) {
  if (!plan) return {
    plan: scheduleBlink(now, r, r2),
    fire: false
  };
  if (now < plan.at) return {
    plan,
    fire: false
  };
  if (plan.left > 1) return {
    plan: {
      at: now + DOUBLE_GAP_MS,
      left: plan.left - 1
    },
    fire: true
  };
  return {
    plan: scheduleBlink(now, r, r2),
    fire: true
  };
}
